export const calcCommission = (amount: number, commissionPercent: number): number =>
  (amount / 100) * commissionPercent
